<template>
  <div :class="`alert alert-custom alert-${infoType}`" role="alert">
    <div class="alert-icon"><i :class="infoIcon"></i></div>
    <div class="alert-text" v-html="$t(infoText)"></div>
  </div>
</template>

<script>
export default {
  name: 'InformationAlert',
  props: {
    infoText: {
      type: String,
      default: 'alert.moduleUnderMaintenance',
    },
    infoType: {
      type: String,
      default: 'warning',
    },
    infoIcon: {
      type: String,
      default: 'flaticon-warning',
    },
  },
}
</script>
